/* eslint-disable jira/filename-case */
export const RESOURCE_TYPE_CONTEXT_PANEL_ISSUE_DETAILS = 'CONTEXT_PANEL_ISSUE_DETAILS';
export const RESOURCE_TYPE_AI_CONTEXT_PANEL = 'AI-CONTEXT-PANEL-RESOURCE-TYPE';
export const RESOURCE_TYPE_AI_CONTEXT_PANEL_WITH_DEPENDENCIES =
	'AI-CONTEXT-PANEL-RESOURCE-TYPE-WITH-DEPENDENCIES';
export const RESOURCE_TYPE_RESOLUTION_PLAN_SSR = 'RESOLUTION-PLAN-SSR-RESOURCE-TYPE';
export const RESOLUTION_PLAN_SSR_BUDGET_MS = 800;
